module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-getStarted",
    class: {
      'hidden': _vm.pagePath === '/newcustomer'
    }
  }, [_c('ButtonBlock', {
    attrs: {
      "blockModifiers": ['largeFont', 'hoverHightlight'],
      "text": 'Get started'
    },
    nativeOn: {
      "click": function($event) {
        _vm.openGetStartedMenu($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-container"
  }, [_c('div', [_c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/service'
    },
    attrs: {
      "to": "/service"
    }
  }, [_vm._v("The Spotin service")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/publishers'
    },
    attrs: {
      "to": "/publishers"
    }
  }, [_vm._v("Spotin for publishers")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/sellers'
    },
    attrs: {
      "to": "/sellers"
    }
  }, [_vm._v("Spotin for sellers")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/contentcommerce'
    },
    attrs: {
      "to": "/contentcommerce"
    }
  }, [_vm._v("What is content commerce?")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "ga",
      rawName: "v-ga",
      value: ('goToDemo'),
      expression: "'goToDemo'"
    }],
    staticClass: "footer-link",
    on: {
      "click": _vm.goToDemo
    }
  }, [_vm._v("Try demo")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/news'
    },
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("News")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/press'
    },
    attrs: {
      "to": "/press"
    }
  }, [_vm._v("Press")])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "footer-link m-active m-noHover"
  }, [_vm._v("Products")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/incontent'
    },
    attrs: {
      "to": "/incontent"
    }
  }, [_c('icon-gb', {
    class: ['footer-icon'],
    attrs: {
      "name": 'spotin-com-submenu'
    }
  }), _vm._v(" In-content commerce")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/shop'
    },
    attrs: {
      "to": "/shop"
    }
  }, [_c('icon-gb', {
    class: ['footer-icon'],
    attrs: {
      "name": 'spotin-com-submenu'
    }
  }), _vm._v("Virtual marketplace")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/checkout'
    },
    attrs: {
      "to": "/checkout"
    }
  }, [_c('icon-gb', {
    class: ['footer-icon'],
    attrs: {
      "name": 'spotin-com-submenu'
    }
  }), _vm._v("Bag & Checkout")], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-link m-active m-noHover"
  }, [_vm._v("Tools")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/commercemanager', 'm-disabled': false
    },
    attrs: {
      "to": "/commercemanager"
    }
  }, [_c('icon-gb', {
    class: ['footer-icon'],
    attrs: {
      "name": 'spotin-com-submenu'
    }
  }), _vm._v("Commerce Manager")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/portal'
    },
    attrs: {
      "to": "/portal"
    }
  }, [_c('icon-gb', {
    class: ['footer-icon'],
    attrs: {
      "name": 'spotin-com-submenu'
    }
  }), _vm._v("Spotin Portal")], 1)], 1), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/about'
    },
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About us")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/terms'
    },
    attrs: {
      "to": "/terms"
    }
  }, [_vm._v("Terms & conditions")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/privacy'
    },
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v("Privacy & integrity policy")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/career'
    },
    attrs: {
      "to": "/career"
    }
  }, [_vm._v("Career")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/support'
    },
    attrs: {
      "to": "/support"
    }
  }, [_vm._v("Support")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/faq'
    },
    attrs: {
      "to": "/faq"
    }
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-link",
    class: {
      'm-active': _vm.pagePath === '/contact'
    },
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer-social"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/spotinab",
      "target": "_blank"
    }
  }, [_c('ImageBlock', {
    staticClass: "footer-socialLink",
    attrs: {
      "data": {
        src: 'Linkedin_20x20.svg',
        alt: 'Linkedin'
      }
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/spotinofficial/",
      "target": "_blank"
    }
  }, [_c('ImageBlock', {
    staticClass: "footer-socialLink",
    attrs: {
      "data": {
        src: 'Instagram_20x20.svg',
        alt: 'Instagram'
      }
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/spotinab",
      "target": "_blank"
    }
  }, [_c('ImageBlock', {
    staticClass: "footer-socialLink",
    attrs: {
      "data": {
        src: 'Facebook_20x20.svg',
        alt: 'Facebook'
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright"
  }, [_vm._v("© Spotin AB, Sweden 2015-2023. All rights reserved")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f8dd521","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/globalBlocks/Footer.vue
// module id = 531
// module chunks = 0